import { UserInfo } from "@shared/models";
import { Member, useAppStore } from "~/store";
import { Group } from "~/types/group";

/**
 * Type for the return value of the useUserHome hook
 */
export interface UserHomeHookResult {
  user: UserInfo | undefined;
  defaultGroup: Group | null | undefined;
  groupMembers:
    | Array<{
        id: number;
        groupId: number;
        role: string;
        joinedAt: Date;
        addedByUserId: number;
        member: Member;
      }>
    | undefined;
  isLoaded: boolean;
}

/**
 * Hook to access user home data from the global store
 * @returns Object with user, defaultGroup, and groupMembers
 */
export function useUserHome(): UserHomeHookResult {
  const userHomeData = useAppStore((state) => state.userHomeData);

  return {
    user: userHomeData?.user,
    defaultGroup: userHomeData?.defaultGroup,
    groupMembers: userHomeData?.groupMembers,
    isLoaded: !!userHomeData
  };
}

/**
 * Hook to get a specific group member by ID
 * @param memberId The ID of the member to get
 * @returns The group member object or undefined if not found
 */
export function useGroupMember(memberId: number) {
  const { groupMembers } = useUserHome();

  if (!groupMembers) return undefined;

  return groupMembers.find((gm) => gm.member.id === memberId);
}
